import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "APP" }

import { checkBrowser, DeviceTYPE, BrowserTYPE } from './ts/utils';
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const browser = checkBrowser();
if (browser.deviceType != DeviceTYPE.DESKTOP) {
  ElMessage({
    message: 'please use PC to get better experience',
    type: 'warning',
    duration: 0,
    showClose: true,
  })
}else if (browser.browserType != BrowserTYPE.EDGE && browser.browserType != BrowserTYPE.CHROME){
  ElMessage({
    message: 'suggest use Chrome or Edge',
    type: 'warning',
    duration: 0,
    showClose: true,
  })
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})